import { useLanguage } from '../hooks/useLanguage.jsx';

export default function LanguageToggle() {
  const { language, toggleLanguage } = useLanguage();

  return (
    <button
      type="button"
      className="language-toggle"
      onClick={toggleLanguage}
      aria-pressed={language === 'en'}
    >
      <span className={language === 'fr' ? 'active' : ''}>FR</span>
      <span className="divider">/</span>
      <span className={language === 'en' ? 'active' : ''}>EN</span>
    </button>
  );
}
